import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-office-orders',
  templateUrl: './office-orders.component.html',
  styleUrls: ['./office-orders.component.scss']
})
export class OfficeOrdersComponent implements OnInit {
  
  selectedLang :any;
  images = [
    // { 
    //   previewImageSrc: '../../../assets/home/h-img3.png',
    // },
    { 
      previewImageSrc: '../../../assets/home/h-img1.png',
    },
    { 
      previewImageSrc: '../../../assets/home/h-img2.png',
    },
    {
      previewImageSrc: '../../../assets/home/h-img4.png',
    },
    {
      previewImageSrc: '../../../assets/home/h-img5.png',
    },
  ];

    responsiveOptions:any[] = [
        {
            breakpoint: '1024px',
            numVisible: 5
        },
        {
            breakpoint: '768px',
            numVisible: 3
        },
        {
            breakpoint: '560px',
            numVisible: 1
        }
    ];

  constructor(private translateService: TranslateService) {}

  ngOnInit() {
    if(localStorage.getItem('lang')) {
      this.selectedLang = localStorage.getItem('lang') ? JSON.parse(localStorage.getItem('lang')) : ''
      this.translateService.use(this.selectedLang .code)
    }
  }

  languageChange(event) {
   localStorage.setItem('lang', JSON.stringify(event.value))
       this.translateService.use(event.value.code)

   
  }
}
